import { errorNotificationMessage, notificationType } from '../../constants/notificationType';
import { openNotification } from './openNotification';

export const openBasicErrorNotification = (customMessageText = null) => {
    openNotification(
        notificationType.error,
        'Error',
        customMessageText ?? errorNotificationMessage
    );
};

export const openBasicSuccessNotification = (
    customMessageText = null,
    title = 'Success',
    duration = 30
) => {
    openNotification(notificationType.success, title, customMessageText ?? '', duration);
};

export const openBasicWarningNotification = (customMessageText = null, title = 'Warning') => {
    openNotification(notificationType.warning, title, customMessageText ?? '');
};
